module.exports = __webpack_public_path__ + "static/media/pin2.8d0a0b84.png";